import openErrorModal from "../../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../../Error/ErrorUtilities";
import { createVariant, fetchCreateVariantModal } from "../../HTTPRequests/VariantRequests";
import Mediator from "../../Utilities/Mediator";
import VariantBaseModal from "./VariantBaseModal";

export default class CreateVariantModal extends VariantBaseModal {
	modalDiv: HTMLDivElement;
	serviceId: string;

	constructor(serviceId: string) {
		super();
		this.modalDiv = document.createElement('div');
		this.serviceId = serviceId;
	}

	public addCreateModalClickListener() {
		const createButton: HTMLButtonElement = document.querySelector(".create-btn__variant");
		createButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchCreateVariantModal();
		}
	}

	private fetchCreateVariantModal() {
		fetchCreateVariantModal()
			.then((response: string) => {
				this.openCreateModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openCreateModal(modalHTMLString: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);

		this.addInputNumberEventsListeners("#create-variant-modal");
		this.addUploadImageChangeEventListener();
		this.addModalButtonsClickListeners();
		this.addDescriptionModalEventsListeners(this.modalDiv);
	}

	private addModalButtonsClickListeners() {
		const cancelButton: HTMLButtonElement = document.querySelector('#create-variant-modal button');
		cancelButton.onclick = () => {
			this.modalDiv.remove();
		};

		const img: HTMLImageElement = document.querySelector('#create-variant-modal img[alt="close icon"]');
		img.onclick = () => {
			this.modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#create-variant-modal button + button');
		saveButton.onclick = () => {
			this.saveCreatedVariant();
		}
	}

	private saveCreatedVariant() {
		const form: HTMLFormElement = document.querySelector("#create-variant-modal form");
		form.onsubmit = ev => ev.preventDefault();
		let { valid, variantFormData } = this.getModalData(form);
		if (valid) {
			document.body.append(this.loadingScreen);
			this.createVariant(variantFormData);
		} else {
			form.reportValidity();
		}
	}

	private createVariant(variantFormData: FormData) {
		createVariant(this.serviceId, variantFormData)
			.then(() => {
				this.modalDiv.remove();
				Mediator.emit("variantCrudOperationFinished");
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
